$(document).ready(function() {
	
	// block :: contact form :: subject cards 
	$('.metro-subject-card').on('click', function(event) {
		var input = $(this).attr('data-choice-id');
		$('#' + input).prop('checked', true);
	});
	
});